'use client'
import React, { useCallback, useRef } from 'react'
import { useReferralCode } from '@l2p/swr-hooks'
import styles from './styles.module.scss'
import { useTranslations } from 'next-intl'

const ReferralLink: React.FC = () => {
  const t = useTranslations('translation')
  const { data } = useReferralCode()
  const codeRef = useRef<HTMLDivElement>(null)
  const copiedRef = useRef<HTMLDivElement>(null)
  const copyIconRef = useRef<HTMLImageElement>(null)

  const copyHandler = useCallback(() => {
    if (copiedRef.current) copiedRef.current.style.display = 'block'
    if (copyIconRef.current) copyIconRef.current.style.display = 'none'
    window.navigator.clipboard.writeText(
      `${window.location.host}/?invite=${data}`,
    )

    setTimeout(() => {
      if (copiedRef.current) copiedRef.current.style.display = 'none'
      if (copyIconRef.current) copyIconRef.current.style.display = 'block'
    }, 1000)
  }, [data])

  if (!data) return null

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>{t('referralLink')}:</div>
      <div className={styles.container} ref={codeRef} onClick={copyHandler}>
        <span className={styles.link}>{data}</span>
        {/*eslint-disable-next-line*/}
				<img className={styles.copy} ref={copyIconRef} src="/img/referral/refCopy.svg" alt="copy" />
        <div className={styles.linkCopied} ref={copiedRef}>
          {t('copied')}
        </div>
      </div>
    </div>
  )
}

export default ReferralLink
